import * as tslib_1 from "tslib";
import { SentimentColors } from "../../../constants";
import cx from 'classnames';
import React, { PureComponent } from 'react';
import { getItem, getPercent } from '../../../utils/card-value';
import { isFiniteNumber } from '../../../utils/checks';
import { getSentimentColor } from '../utils';
import Styles from "./GaugeViewChart.css";
import GaugeViewChartSvg from './GaugeViewChartSvg';

var GaugeViewChart =
/** @class */
function (_super) {
  tslib_1.__extends(GaugeViewChart, _super);

  function GaugeViewChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getDegree = function (value) {
      if (isFiniteNumber(value)) {
        var _a = _this.props,
            min = _a.min,
            max = _a.max;
        return 180 * getPercent(value, min, max) - 90; // -> float: -90..90
      }
    };

    return _this;
  }

  GaugeViewChart.prototype.render = function () {
    var _a = this.props,
        min = _a.min,
        max = _a.max,
        value = _a.value,
        getLabel = _a.getLabel;
    var color = getItem(SentimentColors, value, min, max);
    return React.createElement("div", {
      className: Styles.gaugeViewChart
    }, React.createElement(GaugeViewChartSvg, {
      color: color,
      degree: this.getDegree(value)
    }), React.createElement("div", {
      className: Styles.labels
    }, React.createElement("div", {
      className: Styles.min
    }, getLabel(min)), React.createElement("div", {
      className: cx(Styles.value, getSentimentColor(color, Styles))
    }, getLabel(value)), React.createElement("div", {
      className: Styles.max
    }, getLabel(max))));
  };

  return GaugeViewChart;
}(PureComponent);

export default GaugeViewChart;